import { render } from "./tradeArea.vue?vue&type=template&id=e90f60f0"
import script from "./tradeArea.vue?vue&type=script&lang=js"
export * from "./tradeArea.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__